import service from '../config/services';

const { domain } = service;


export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function (...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}
// 根据某个属性值从MenuList查找拥有该属性值的menuItem
export function getMenuItemInMenuListByProperty(menuList, key, value) {
  let stack = [];
  stack = stack.concat(menuList);
  let res;
  while (stack.length) {
    let cur = stack.shift();
    if (cur.children && cur.children.length > 0) {
      stack = cur.children.concat(stack);
    }
    if (value === cur[key]) {
      res = cur;
    }
  }
  return res;
}

/**
 * @description 将时间戳转换为年-月-日-时-分-秒格式
 * @param {String} timestamp
 * @returns {String} 年-月-日-时-分-秒
 */
export function timestampToTime(timestamp) {
  var date = new Date(timestamp);
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
  var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
  var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());

  let strDate = Y + M + D + h + m + s;
  return strDate;
}


/**
 * @description 获取时区偏移量
 * @returns {Number} 时区偏移量
 */
export function getTimeZoneOffset() {
  return new Date().getTimezoneOffset();
}

/**
 * @description 将数组根据某个字段进行排序
 * @param 字段名
 * @returns 返回排序好的数组
 */
export function arraySort(field) {
  return (a, b) => {
    const value1 = a[field]
    const value2 = b[field]
    return value1 - value2
  }
}

export function groupBy(list, name) {
  return list.reduce((obj, item) => {
    if (!obj[item[name]]) {
      obj[item[name]] = []
      obj[item[name]].push(item)
    } else {
      obj[item[name]].push(item)
    }
    return obj
  }, {})
}

/**
 * 是否在微信客户端
 */
export function isInWechat() {
  var ua = window.navigator.userAgent.toLowerCase();
  return ua.includes('micromessenger')
}

//是否是苹果浏览器
export function isAppleBrowser() {
  var ua = window.navigator.userAgent.toLowerCase();
  return ua.includes('iphone') || ua.includes('ipad')
  // || ua.includes('macintosh')
}

//json 转换 object
export function formatJSON(str) {
  //是否是json字符串，不是则返回str

  if (typeof str === 'object')
    return str;

  if (typeof str === 'string') {
    try {
      return JSON.parse(str);
    } catch (ex) {
      return null;
    }
  }
}

export function isVideoFile(fileName) {
  const videoExtensions = [".mp4", ".avi", ".mov", ".mkv", ".wmv", ".flv"];
  const fileExtension = fileName.substr(fileName.lastIndexOf('.')).toLowerCase();
  return videoExtensions.includes(fileExtension);
}

export function isURLValid(url) {
  // 定义一个正则表达式模式，用于匹配有效的 URL 格式
  const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;

  // 使用正则表达式测试给定的 URL
  return urlPattern.test(url);
}

export function getUrlParam(key) {
  let url = window.location.href;
  if (url.indexOf('#rd') > -1) {
    url = url.replace('#rd', '');
  }
  const sValue = url.match(new RegExp('[?&]' + key + '=([^&]*)(&?)', 'i'));

  const res = sValue ? sValue[1] : sValue;
  return res && decodeURI(res);
}

export function isImageFile(fileName) {
  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
  const fileExtension = fileName.substr(fileName.lastIndexOf('.')).toLowerCase();
  return imageExtensions.includes(fileExtension);
}

/**
 * @description 去除html标签
 * @param {String} str 
 * @returns {String} 去除html标签后的字符串
 */
export function stripHtmlTags(str) {
  return str.replace(/<[^>]*>?/g, '');
}

export function renderImageUrl({ size = 'b', src }) {
  if (!src) return ''
  try {
    // 获取最后一个斜杠的位置
    const lastSlashIndex = src.lastIndexOf('/');
    // 获取最后一个点的位置
    const lastDotIndex = src.lastIndexOf('.');

    if (lastSlashIndex === -1 || lastDotIndex === -1) return src;

    // 获取路径部分和文件名部分
    let path = src.substring(0, lastSlashIndex + 1);

    // 匹配路径
    if (/^https?:\/\/(file|test-file)\.jimutour\.com/.test(path)) {
      // path = path.replace(/^https?:\/\/file\.jimutour\.com/, domain.fileCDN) ;
      path = replaceCDNDomain(path)

    }

    const fileName = src.substring(lastSlashIndex + 1, lastDotIndex);
    const extension = src.substring(lastDotIndex);

    return `${path}${fileName}_${size}${extension}`;
  } catch (error) {
    return src;
  }
}

/**
 * @description 使用CDN域名
 * @param {String} src 
 * @returns {String} 使用CDN域名后的字符串
 */
export function replaceCDNDomain(src = '') {
  if (!src) return ''

  //是否启用CDN
  if (!window.enableCDNFlag) return src

  try {
    return src.replace(/^https?:\/\/file\.jimutour\.com/, domain.fileCDN)
  } catch (error) {
    return src
  }
}

/**
 * @description 解码HTML实体
 * @param {String} str 
 * @returns {String} 解码后的字符串
 */
export function decodeHtmlEntities(str) {
  if (!str) return '';

  const textarea = document.createElement('textarea');
  textarea.innerHTML = str;
  return textarea.value;
}

/**
 * @description 增强的HTML实体解码函数，支持更多实体
 * @param {String} str 
 * @returns {String} 解码后的字符串
 */
export function decodeHtmlEntitiesEnhanced(str) {
  if (!str) return '';

  // 常见的HTML实体映射
  const htmlEntities = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&apos;': "'",
    '&nbsp;': ' ',
    '&copy;': '©',
    '&reg;': '®',
    '&trade;': '™',
    '&hellip;': '...',
    '&mdash;': '—',
    '&ndash;': '–',
    '&lsquo;': "'",
    '&rsquo;': "'",
    '&ldquo;': '"',
    '&rdquo;': '"',
    '&bull;': '•',
    '&deg;': '°',
    '&plusmn;': '±',
    '&times;': '×',
    '&divide;': '÷',
    '&frac12;': '½',
    '&frac14;': '¼',
    '&frac34;': '¾',
    '&euro;': '€',
    '&pound;': '£',
    '&yen;': '¥',
    '&cent;': '¢',
    '&sect;': '§',
    '&para;': '¶',
    '&micro;': 'µ'
  };

  let result = str;

  // 处理命名实体
  for (const [entity, char] of Object.entries(htmlEntities)) {
    result = result.replace(new RegExp(entity, 'g'), char);
  }

  // 处理数字实体 (如 &#38;, &#x26;)
  result = result.replace(/&#(\d+);/g, (match, dec) => {
    return String.fromCharCode(parseInt(dec, 10));
  });

  result = result.replace(/&#x([0-9a-fA-F]+);/g, (match, hex) => {
    return String.fromCharCode(parseInt(hex, 16));
  });

  return result;
}

/**
 * @description 批量解码对象中的HTML实体
 * @param {Object} obj - 需要解码的对象
 * @param {Array} fields - 需要解码的字段名数组，如果不提供则解码所有字符串字段
 * @returns {Object} 解码后的对象
 */
export function decodeObjectHtmlEntities(obj, fields = null) {
  if (!obj || typeof obj !== 'object') return obj;

  const result = Array.isArray(obj) ? [] : {};

  for (const [key, value] of Object.entries(obj)) {
    if (typeof value === 'string') {
      // 如果指定了字段，只解码指定字段
      if (!fields || fields.includes(key)) {
        result[key] = decodeHtmlEntitiesEnhanced(value);
      } else {
        result[key] = value;
      }
    } else if (typeof value === 'object' && value !== null) {
      // 递归处理嵌套对象
      result[key] = decodeObjectHtmlEntities(value, fields);
    } else {
      result[key] = value;
    }
  }

  return result;
}

/**
 * @description 解码数组中的HTML实体
 * @param {Array} arr - 需要解码的数组
 * @param {Array} fields - 需要解码的字段名数组
 * @returns {Array} 解码后的数组
 */
export function decodeArrayHtmlEntities(arr, fields = null) {
  if (!Array.isArray(arr)) return arr;

  return arr.map(item => {
    if (typeof item === 'object' && item !== null) {
      return decodeObjectHtmlEntities(item, fields);
    }
    return item;
  });
}


/**
 * @description 日期计算
 * @param {String} strInterval 
 * @param {Date} date 
 * @param {Number} Number 
 * @returns {Date} 日期计算后的日期
 */
export function dateAdd(strInterval, date, Number) {
  var dtTmp = date;
  switch (strInterval) {
    case 's':
      return new Date(Date.parse(dtTmp) + (1000 * Number));
    case 'n':
      return new Date(Date.parse(dtTmp) + (60000 * Number));
    case 'h':
      return new Date(Date.parse(dtTmp) + (3600000 * Number));
    case 'd':
      return new Date(Date.parse(dtTmp) + (86400000 * Number));
    case 'w':
      return new Date(Date.parse(dtTmp) + ((86400000 * 7) * Number));
    case 'q':
      return new Date(dtTmp.getFullYear(), (dtTmp.getMonth()) + Number * 3, dtTmp.getDate(), dtTmp.getHours(), dtTmp.getMinutes(), dtTmp.getSeconds());
    case 'm':
      return new Date(dtTmp.getFullYear(), (dtTmp.getMonth()) + Number, dtTmp.getDate(), dtTmp.getHours(), dtTmp.getMinutes(), dtTmp.getSeconds());
    case 'y':
      return new Date((dtTmp.getFullYear() + Number), dtTmp.getMonth(), dtTmp.getDate(), dtTmp.getHours(), dtTmp.getMinutes(), dtTmp.getSeconds());
  }
}

/**
 * @description 补0
 * @param {Number} n 
 * @returns {Number} 补0后的数字
 */
export function addZero(n) {
  if (n < 10) {
    return '0' + n;
  }
  return n;
}